import { GameModule } from '@long-game/game-definition';

export default {
  id: 'heir-apparent',
  title: 'Heir Apparent',
  versions: [{ version: 'v1', devUIPort: 3405, devAPIPort: 3505 }],
  tags: [],
  creators: [],
  prerelease: true,
} satisfies GameModule;
